/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupplierLocationMappingFormDataConfiguration
 */
export interface SupplierLocationMappingFormDataConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SupplierLocationMappingFormDataConfiguration
     */
    suppliers?: Array<GuidIdAndLabel> | null;
}

export function SupplierLocationMappingFormDataConfigurationFromJSON(json: any): SupplierLocationMappingFormDataConfiguration {
    return SupplierLocationMappingFormDataConfigurationFromJSONTyped(json, false);
}

export function SupplierLocationMappingFormDataConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierLocationMappingFormDataConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function SupplierLocationMappingFormDataConfigurationToJSON(value?: SupplierLocationMappingFormDataConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


